import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getTimeslots, getBookingTimeslots, getAllBookingTimeslots } from './timeslotsThunk';
import { mappingTimeslots } from '../lib/helpers/mapping/mappingTimeslots';
import {
	BookingSlot,
	Timeslot,
	TimeslotState,
} from './types';
import {
	createTimesOptions,
	extractBookingTimes,
} from '../lib/helpers/timeslotDateTIme/timeslotDate';
import { CustomError } from 'shared/api';

const initialState: TimeslotState = {
	timeslots: [],
	timeslotsMap: [],
	bookingTimes: [],
	allBookingTimes: [],
	timesOptions: [],
	selectedTimeslot: '',
	lastTimeUsed: new Date(),
	loading: true,
	error: null,
	loadingBookingSlots: true,
	errorBookingSlots: null,
};

const timeslotsSlice = createSlice({
	name: 'timeslots',
	initialState,
	reducers: {
		toSelectTimeslot: (
			state,
			action: PayloadAction<{
				slot: string;
			}>,
		) => {
			const slot = action.payload.slot;
      console.log('toSelectTimeslot',slot);

			state.selectedTimeslot = slot;

			state.lastTimeUsed = new Date();
		},
		// TODO проверить все места isToday
	},
	extraReducers: builder =>
		builder
			.addCase(getTimeslots.pending, state => {
				// if (!state.timeslots.length) {
				// 	state.loading = true;
				// }
				state.error = null;
			})
			.addCase(
				getTimeslots.fulfilled,
				(state, action: PayloadAction<Timeslot[]>) => {
					const timeslots = action.payload;

					const timeslotsMap = mappingTimeslots(timeslots);
					
					state.timesOptions = createTimesOptions(timeslots);
					
					state.timeslotsMap = timeslotsMap;
					state.timeslots = action.payload;

          const actionAny = action as any;
          const selectNewSlotByDate = actionAny.meta?.arg?.selectNewSlotByDate;
          if (selectNewSlotByDate) {
            const now = new Date();
            const finded = timeslots.find(timeslot => new Date(timeslot.dt_start).getTime() < now.getTime()&&now.getTime() <= new Date(timeslot.dt_end).getTime())

            if (finded) {
              state.selectedTimeslot = finded.dt_start;
            }
          }

					state.loading = false;
					state.error = null;
				},
			)
			.addCase(getTimeslots.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as CustomError;
			})
			.addCase(getBookingTimeslots.pending, state => {
				state.loadingBookingSlots = true;
				state.errorBookingSlots = null;
			})
			.addCase(
				getBookingTimeslots.fulfilled,
				(state, action: PayloadAction<BookingSlot[]>) => {
					const timeslots = action.payload;
					state.bookingTimes = extractBookingTimes(timeslots);

					state.loadingBookingSlots = false;
					state.errorBookingSlots = null;
				},
			)
			.addCase(getBookingTimeslots.rejected, (state, action) => {
				state.loadingBookingSlots = false;
				state.errorBookingSlots = action.payload ?? null;
			})

			.addCase(getAllBookingTimeslots.pending, state => {
				// state.loadingBookingSlots = true;
				state.errorBookingSlots = null;
			})
			.addCase(
				getAllBookingTimeslots.fulfilled,
				(state, action: PayloadAction<BookingSlot[]>) => {
					const timeslots = action.payload;
					state.allBookingTimes = extractBookingTimes(timeslots);

					// state.loadingBookingSlots = false;
					state.errorBookingSlots = null;
				},
			)
			.addCase(getAllBookingTimeslots.rejected, (state, action) => {
				// state.loadingBookingSlots = false;
				state.errorBookingSlots = action.payload ?? null;
			}),
});

export const timeslotsReducer = timeslotsSlice.reducer;
export const {
	toSelectTimeslot,
} = timeslotsSlice.actions;
